module.exports = "/static/media/calendar.f1032a3e.svg";